import { encrypt } from "./crypto";

/**
 * Generate document acceptance link
 * @param {number} candidateId - Candidate ID
 * @param {number} companyId - Company ID  
 * @param {number} documentId - Document ID
 * @returns {string} - Generated acceptance link
 */
export const generateDocumentAcceptanceLink = (candidateId, companyId, documentId) => {
  try {
    // Create data object to encrypt
    const data = {
      candidateId: candidateId,
      companyId: companyId,
      documentId: documentId,
      timestamp: new Date().getTime() // Add timestamp for security
    };

    // Encrypt the data
    const encryptedToken = encrypt(JSON.stringify(data));
    
    // Generate the acceptance link
    const baseUrl = window.location.origin;
    const acceptanceLink = `${baseUrl}/candidates/document-acceptance?token=${encodeURIComponent(encryptedToken)}`;
    
    return acceptanceLink;
  } catch (error) {
    console.error('Error generating document acceptance link:', error);
    throw new Error('Failed to generate document acceptance link');
  }
};

/**
 * Copy text to clipboard
 * @param {string} text - Text to copy
 * @returns {Promise<boolean>} - Success status
 */
export const copyToClipboard = async (text) => {
  try {
    if (navigator.clipboard && window.isSecureContext) {
      await navigator.clipboard.writeText(text);
      return true;
    } else {
      // Fallback for older browsers
      const textArea = document.createElement('textarea');
      textArea.value = text;
      textArea.style.position = 'fixed';
      textArea.style.left = '-999999px';
      textArea.style.top = '-999999px';
      document.body.appendChild(textArea);
      textArea.focus();
      textArea.select();
      
      const success = document.execCommand('copy');
      textArea.remove();
      return success;
    }
  } catch (error) {
    console.error('Failed to copy to clipboard:', error);
    return false;
  }
};